var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.stepName,staticStyle:{"position":"relative"}},[_vm._m(0),_vm._v(" "),_c('PhoneForm')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-header"},[_c('p',[_vm._v("Vul je gsm-nummer in")]),_vm._v(" "),_c('p',[_c('span',[_vm._v("Om uw transactie te beveiligen, gelieve uw gsm-nummer in het onderstaande veld in te voeren. U ontvangt een beveiligde link via sms.")])])])
}]

export { render, staticRenderFns }